//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

// === COMPONENTS ===
import { ExpressionContext } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function OperatorControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, data, is_predicate } = props;
  
  const theme = useTheme();

  const _operator_items = [
    { label: 'AND'    , value: 'AND' },
    { label: 'OR'     , value: 'OR'  },
    { label: '='      , value: '='   },
    { label: '!='     , value: '!='  },
    { label: '+'      , value: '+'   },
    { label: '-'      , value: '-'   },
    { label: '>'      , value: '>'   },
    { label: '<'      , value: '<'   },
    { label: '>='     , value: '>='  },
    { label: '<='     , value: '<='  },
    { label: '('     , value: '('  },
    { label: ')'     , value: ')'  },
  ]

  const _symbol_colors = {
    undefined: theme.palette.background.primary[theme.palette.mode],
    'AND' : '#00FFFF',
    'OR'  : '#00FF00',
    '='   : '#00FF00',
    '!='  : '#FF0000',
    '+'   : '#B882ED',
    '-'   : '#B882ED',
    '>'   : '#BC8F8F',
    '<'   : '#BC8F8F',
    '>='  : '#BC8F8F',
    '<='  : '#BC8F8F',
    '('  : '#BDA68F',
    ')'  : '#BDA68F',
  }

  const { updateExpression, updatePredicate } = useContext( ExpressionContext );

  const [ symbol, setSymbol ] = useState( data?.symbol );

  const _color = _symbol_colors[symbol];
  const _color_alpha = theme.palette.mode === 'light' ? getHexAlpha( 60 ) : getHexAlpha( 60 );

  //#endregion

  //#region [STYLES]

  const _styles = {
    select_operator: {
      height: '3rem',
      width: '9rem',
      backgroundColor: _color + _color_alpha,
    },
  }
  
  const SELECT_OPERATOR = {
    sx: _styles.select_operator,
    labelId: 'operator-label',
    id     : 'operator-select',
    label  : 'Symbol',
    value  : symbol,
    onChange : onChange,
    children: _operator_items.map( item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    setSymbol( event.target.value )
    const update = is_predicate ? updatePredicate : updateExpression;
    update( id , { symbol: event.target.value } )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <FormControl>
          <InputLabel id="operator-label">Symbol</InputLabel>
          <Select { ...SELECT_OPERATOR } />
        </FormControl>
      </>
    );
  }

  //#endregion

  return display();
}
